module.exports = "//static.hsappstatic.net/salesImages/static-1.403/onboarding/checklist-item-confirm-email.png"